import { Component } from 'react'
import Modal from '../modal'
import successIcon from '../../../assets/icons/success.png'
import errorIcon from '../../../assets/icons/warning.png'
import './styles.sass'

interface ModalProps {
    render: boolean,
    type: 'success' | 'error',
    title: string,
    text?: any,
    onClose: () => void
}  

export default class ResponseModal extends Component<ModalProps> {
  render() {
    // Suporta string, função que retorna JSX, ou elemento React diretamente
    const renderText = () => {
      if (!this.props.text) return null;
      
      if (typeof this.props.text === 'function') {
        return this.props.text();
      }
      
      if (typeof this.props.text === 'string') {
        return <p>{this.props.text}</p>;
      }
      
      // Se for um elemento React diretamente
      return this.props.text;
    };

    return (
      <Modal render={this.props.render} onClose={() => this.props.onClose()}>
        <div className='modal-content'>
          <img src={this.props.type === 'success' ? successIcon : errorIcon} alt={this.props.type+'_icon'} className='icon' />
          <h3>{this.props.title}</h3>
          {renderText()}
        </div>
      </Modal>
    )
  }
}
